import { registerAction } from '../../Action'

const LOAD_MOMENTS = 'LOAD_MOMENTS'

const reducer = (state = {}, action) => ({
  ...state,
  moments: action.payload.data,
})

const loadMoments = registerAction(LOAD_MOMENTS, { reducer })

export default loadMoments
